// extracted by mini-css-extract-plugin
export default {"wrapper":"SelfiesTip_style_wrapper__hnm6d","rotate":"SelfiesTip_style_rotate__ySMmG"};